import React from "react";
import { useHistory } from "react-router-dom";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

const UpgradeService = (props: { categoryName: string; upgradableText: string }) => {
    const history = useHistory();

    return (
        <div className="box offset-padding offer">
            <div className="box-header">
                <div className="box-title-container no-margin">
                    <div className="box-title-icon" aria-hidden="true">
                        <RenderIcons iconName={"tachometer-alt"} />
                    </div>
                    <div className="box-title-text has-actions">
                        <h2 className="box-title">{props.categoryName}</h2>
                    </div>
                </div>

                <div className="box-actions">
                    <button
                        type="button"
                        className="btn-default btn-primary"
                        onClick={() => {
                            window.addToDataLayer({ event: "Upgrade Service Click" });
                            history.push("/manage-account/protection-plan");
                        }}
                    >
                        <span className="btn-text">{props.upgradableText}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradeService;
